/**
 * Billing: Stripe checkout / portal and the subscription-tier read used by the
 * advertiser subscription pages. Goes through `businessApi` exactly as those
 * pages do today. (Pricing.jsx reads /subscription-tiers with bare axios; not
 * touched here.) Phase 4 slot-billing calls will be added to this module.
 */
import { businessApi } from './business';

export const getSubscriptionTiers = (config) => businessApi.get('/subscription-tiers', config);
export const createCheckoutSession = (payload, config) => businessApi.post('/stripe/create-checkout-session', payload, config);
export const getCheckoutStatus = (sessionId, config) => businessApi.get(`/stripe/checkout-status/${sessionId}`, config);
export const createPortalSession = (payload = {}, config) => businessApi.post('/stripe/portal-session', payload, config);
